import {Display} from "../../../components/Display";
import {Anomaly} from "../../components/AnomalyItem";
import {Change} from "../../components/ChangeItem";
import * as React from "react";
import {CurrentSettingsUpdateResult} from "../../data/models/CurrentSettingsUpdateResult";
import {AppTranslations} from "../../../components/Utils/translations/AppTranslations";
import {AvailableRegister} from "../../data/models/AvailableRegister";
import {getRegisterByNumber} from "../../ReadAndWrite/utils";

declare var AppTranslations: AppTranslations;

interface ConfigurationHistoryElementProps {
    updateResult: CurrentSettingsUpdateResult;
    availableRegisters: AvailableRegister[];
}

export const ConfigurationHistoryElement: React.FC<ConfigurationHistoryElementProps> = ({updateResult, availableRegisters}) => {


    const getText = () => {
        const numProcessed = updateResult?.numProcessed ?? 0;
        const numExpected = updateResult?.numExpected ?? 0;
        const numChanges = updateResult?.changes?.length ?? 0;
        const numReadings = numProcessed - numChanges;
        const numAnomalies = updateResult?.anomalies?.length ?? 0;

        return `${AppTranslations.readAndWrite.operationsPerformed}: ${numProcessed}/${numExpected} - 
                ${numChanges} ${AppTranslations.readAndWrite.changes}, 
                ${numReadings} ${AppTranslations.readAndWrite.readings}, 
                ${numAnomalies} ${AppTranslations.errorMessages.errors}`;
    }

    return <>
        <Display isVisible={updateResult?.errorMessage}>
            <p className={"configuration-error-message font-size-large padding-bottom-10px bold"}>{updateResult?.errorMessage}</p>
        </Display>
        <p className={"font-size-large padding-bottom-10px"}>{getText()}</p>
        <ul className={"configurations-list"}>
            {(updateResult?.anomalies ?? [])?.map((anomaly, index) =>
                <Anomaly
                    errorMessage={anomaly?.errorMessage}
                    expectedValue={anomaly?.expectedValue}
                    receivedValue={anomaly?.receivedValue}
                    key={index}
                />
            )}
        </ul>
        <ul className={"configurations-list"}>
            {(updateResult?.changes ?? [])?.map((change, index) =>
                <Change
                    value={change?.value}
                    name={change?.name}
                    newValue={change?.newValue}
                    key={index}
                    unitOfMeasure={getRegisterByNumber(change?.reg, availableRegisters)?.um}
                />
            )}
        </ul>
    </>
}